/** See `src/i18n/locales/en/pilots.ts`. */
export const pilots = {
  page: {
    title: 'Pilotes',
    lead: 'Pilotes en cours chez {{company}}.',
    noScope: 'Sélectionnez une entreprise pour voir ses pilotes.',
    listTitle: 'Pilotes',
    empty: "Aucun pilote pour l'instant.",
  },
  status: {
    draft: 'Brouillon',
    baseline: 'Référence',
    active: 'Actif',
    interim_review: 'Évaluation intermédiaire',
    final_review: 'Évaluation finale',
    completed: 'Terminé',
    scaled: 'Déployé',
  },
  phases: {
    baseline: 'Mesure de référence',
    interim: 'Évaluation intermédiaire',
    final: 'Évaluation finale',
  },
  kpis: {
    participationRate: 'Taux de participation',
    activeUsers: 'Utilisateurs actifs',
    dailyUsage: 'Usage quotidien',
    satisfaction: 'Satisfaction des employés',
    avgVitality: 'Vitalité moy.',
    aiCoachUsage: 'Usage du coach IA',
    challengeUsage: 'Usage des challenges',
    rolloutReadiness: 'Recommandation de déploiement',
  },
  form: {
    title: 'Nouveau pilote',
    name: 'Nom',
    startDate: 'Date de début',
    departments: 'Départements',
    submit: 'Créer le pilote',
  },
  detail: {
    title: 'Pilote',
    lead: 'Évaluation du pilote de vitalité avec KPI, tendances, conclusions et une décision de déploiement argumentée.',
    exportPdf: 'Exporter le rapport (PDF)',
    hero: {
      badge: {
        success: 'Pilote réussi',
        partial: 'Pilote en cours',
        atRisk: 'Attention requise',
        pending: "Pilote en cours d'exécution",
      },
      goals: {
        success: 'Tous les objectifs KPI atteints',
        partial: 'Certains objectifs KPI atteints',
        atRisk: 'Objectifs KPI pas encore atteints',
        pending: 'Pas encore assez de données pour une recommandation',
      },
      headlinePrefix: {
        success:
          'Le pilote prouve que NOLATR Fit améliore la vitalité de façon mesurable — recommandation :',
        partial: 'Le pilote montre une amélioration — recommandation :',
        atRisk: "Le pilote ne montre pas encore d'amélioration mesurable — recommandation :",
        pending: "Il n'y a pas encore assez de données pour une recommandation sur",
      },
      headlineAdvice: {
        success: "déployer à l'ensemble de l'organisation.",
        partial: 'prolonger le pilote pour obtenir plus de données.',
        atRisk: 'corriger cela avant de déployer.',
        pending: 'le déploiement.',
      },
    },
    summary: {
      participation: 'Participation',
      dailyActive: 'Actifs quotidiens',
      stress: 'Stress',
      sleep: 'Sommeil',
      goal: 'objectif {{value}}%',
      vsBaseline: 'vs référence',
      minutes: '{{value}} min',
    },
    aiSummaryTitle: 'Résumé IA',
    recommendationEmpty: 'Aucun résumé rédigé pour le moment.',
    kpisTitle: 'KPI',
    chartTitle: 'Vitalité et activité pendant le pilote',
    chartCurrent: 'Actuel',
    noData: 'Aucune donnée pour le moment.',
    participantCount: '{{count}} participants',
    evaluationsTitle: 'Conclusions & recommandations',
    conclusionsTitle: 'Conclusions',
    recommendationsListTitle: 'Recommandations',
    evaluationsEmpty: 'Aucune évaluation enregistrée pour le moment.',
    evaluationPhase: 'Phase',
    evaluationConclusions: 'Conclusions',
    evaluationRecommendations: 'Recommandations',
    decisionTitle: 'Décision',
    scaleRequiresCompleted:
      "Le déploiement n'est possible qu'une fois l'évaluation finale terminée.",
  },
  actions: {
    new: 'Nouveau pilote',
    cancel: 'Annuler',
    save: 'Enregistrer',
    edit: 'Modifier',
    addEvaluation: 'Ajouter une évaluation',
    extend: 'Prolonger',
    scale: 'Déployer',
  },
} as const;
